import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Navigation } from "./components/navigation/navigation";
import JsonData from "./data/data.json";
import SmoothScroll from "smooth-scroll";
import "./App.css";
import { Loader } from "./components/loader/Loader";
import AppRoutes from './AppRoutes';
import { Footer } from "./components/footer/footer";
import LiveChat from "./components/chat/LiveChat";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

const App = () => {
  const [landingPageData, setLandingPageData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a data fetching delay
    setTimeout(() => {
      setLandingPageData(JsonData);
      setLoading(false);
    }, 1000); // Reduced to 1 second
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (!landingPageData) {
    return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold mb-4">No Data Available</h1>
            <p className="text-gray-600">Unable to load application data.</p>
          </div>
        </div>
    );
  }

  return (
      <Router basename="/">
        <div>
          <Navigation />
          <AppRoutes landingPageData={landingPageData} />
          <Footer />
          <LiveChat />
        </div>
      </Router>
  );
};

export default App;